var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Author',{attrs:{"author":_vm.author,"posts":_vm.posts}})
}
var staticRenderFns = []

export { render, staticRenderFns }